import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'ramda';
import Local from '../../Local/Local';
import GameCardsLine from '../GameCardsLine';
import { useRecentGames } from '../../../hooks/useRecentGames';
import { getDataTestAttrs } from '../../../utils/testing-locators';
import { getGames } from '../utils';
import { RECENT_GAMES_LIST } from '../../../constants/dataTestIds';
import { ANALYTICS_SCREEN_AREA_DETAILS } from '../../../constants/analytics';

const GameCardsLineRecentLaunched = ({
  excludeGameIds,
  className,
  analyticsData,
  translationKey,
  ...props
}) => {
  const { data } = useRecentGames();
  const items = getGames(data, excludeGameIds);

  return !isEmpty(items) ? (
    <GameCardsLine
      items={items}
      title={<Local>{translationKey || 'Recent launched games'}</Local>}
      className={className}
      analyticsData={{
        ...analyticsData,
        screen_area_detail: ANALYTICS_SCREEN_AREA_DETAILS.RECENT_GAME,
      }}
      {...getDataTestAttrs(RECENT_GAMES_LIST)}
      {...props}
    />
  ) : null;
};

GameCardsLineRecentLaunched.propTypes = {
  excludeGameIds: PropTypes.array,
  analyticsData: PropTypes.shape({
    screen_name: PropTypes.string,
    screen_area: PropTypes.string,
  }),
  translationKey: PropTypes.string,
};

GameCardsLineRecentLaunched.defaultProps = {
  excludeGameIds: [],
  analyticsData: {},
};

export default GameCardsLineRecentLaunched;
